import script from "./supportPage.vue?vue&type=script&setup=true&lang=js"
export * from "./supportPage.vue?vue&type=script&setup=true&lang=js"

import "./supportPage.vue?vue&type=style&index=0&id=51d63538&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-51d63538"]])

export default __exports__